// Component for clearing the selected refinements on Search Results
import { useClearRefinements } from "react-instantsearch";
import "./ClearRefinements.scss";
import { ReactComponent as RefinementsCloseIcon } from "./Close.svg";

const CustomClearRefinements = (props) => {
    const { canRefine, refine } = useClearRefinements(props);

    // if there are refinements, show the button
    // Clear refinements with the refinement to ' '
    return canRefine ? (
        <button
            className="search-refinements__clear"
            onClick={() => refine("")}
            // disabled={!items}
        >
            Alle Filter löschen
            <RefinementsCloseIcon />
        </button>
    ) : null;
};

export default CustomClearRefinements;
